import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class DesktopPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: [], andSearch: false, search: ['Desktop'], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Desktop Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have written MS Windows applications and drivers in C/C++ since Version 1.x in 1985.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I started Windows development with straight C. In the early 1990's I moved to C++. In 2004 I began to develop .NET applications in C#.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I began Apple desktop development With Mac OS 9 in 1999. I migrated to OS X (macOS) in 2005</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>My first Macintosh development was in C/C++ with Metrowerks Codewarrior for Mac OS. I transitioned to XCode and Objective-C in 2005. I have since added Swift and most recently Kotlin.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Desktop projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default DesktopPlatform



// WEBPACK FOOTER //
// src/Platforms/DesktopPlatform.js